function Products() {
  return (
    <div className="products-page">
      <section className="products-hero">
        <h1>Fresh Organic Products</h1>
        <p>
          Healthy organic fruits and vegetables
          directly from trusted farms.
        </p>
      </section>

    
      <section className="products-section">
        <div className="products-grid">
          <div className="product-card">
            <img
              src="https://images.unsplash.com/photo-1567306226416-28f0efdc88ce"
              alt="Apple"
            />

            <div className="product-content">
              <h3>Organic Apples</h3>
              <p>
                Fresh sweet apples rich in
                vitamins and fiber.
              </p>
            </div>
          </div>

  
          <div className="product-card">
            <img
              src="https://images.unsplash.com/photo-1553279768-865429fa0078"
              alt="Mango"/>

            <div className="product-content">
              <h3>Organic Mangoes</h3>
              <p>
                Naturally ripened juicy mangoes
                full of taste.
              </p>
            </div>
          </div>

          <div className="product-card">
            <img
              src="https://images.unsplash.com/photo-1546094096-0df4bcaaa337"
              alt="Tomato"/>

            <div className="product-content">
              <h3>Fresh Tomatoes</h3>
              <p>
                Farm fresh organic tomatoes with
                natural flavor.
              </p>
            </div>

          </div>

          <div className="product-card">
            <img
              src="https://images.unsplash.com/photo-1589707790848-9097c28e8569?q=80&w=1169&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
              alt="Ginger"/>

            <div className="product-content">
              <h3>Organic Ginger</h3>
              <p>
                Natural organic ginger perfect
                for healthy living.
              </p>
            </div>

          </div>


          <div className="product-card">
            <img
              src="https://images.unsplash.com/photo-1636210589096-a53d5dacd702?q=80&w=1332&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
              alt="Garlic"/>

            <div className="product-content">
              <h3>Fresh Garlic</h3>
              <p>
                Healthy garlic directly sourced
                from organic farms.
              </p>
            </div>
          </div>


          <div className="product-card">
            <img
              src="https://images.unsplash.com/photo-1587049352846-4a222e784d38?q=80&w=880&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
              alt="Watermelon"
            />
            <div className="product-content">
              <h3>Organic Watermelon</h3>
              <p>
                Sweet and juicy watermelon rich
                in freshness.
              </p>
            </div>

          </div>

        </div>

      </section>

    </div>
  );
}

export default Products;